import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { CustomHandlerWithResult } from "@tLinc/Store/CustomHandlerCreator/CustomHandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

type HandlerType = CustomHandlerWithResult<ProductFilters, ProductFilters>;

export const MergeParameter: HandlerType = props => {
    const currentFilters = props.getState().LINCData.myProductsReducer.productFilters;
    const updatedFilters = { ...currentFilters, ...props.parameter };
    props.result = updatedFilters;
};

export const AddAttributeValueFilters: HandlerType = props => {
    const currentFilters = props.getState().LINCData.myProductsReducer.productFilters;
    props.result.attributeValueIds = currentFilters.attributeValueIds;

    if (props.parameter.attributeValueIds) {
        props.result.attributeValueIds = props.parameter.attributeValueIds.concat(props.result.attributeValueIds || []);
    }
};

export const ResetPage: HandlerType = props => {
    if (
        props.parameter.pageSize ||
        props.parameter.sort ||
        props.parameter.pageCategoryId ||
        props.parameter.categoryId ||
        props.parameter.searchWithinQueries?.length ||
        props.parameter.brandIds?.length ||
        props.parameter.productLineIds?.length ||
        props.parameter.priceFilters?.length ||
        props.parameter.attributeValueIds?.length
    ) {
        props.result.page = undefined;
    }
};

export const AddBrandsValueFilters: HandlerType = props => {
    // const currentFilters = props.getState().pages.productList.productFilters;
    const currentFilters = props.getState().LINCData.myProductsReducer.productFilters;

    props.result.brandIds = currentFilters.brandIds;

    if (props.parameter.brandIds) {
        props.result.brandIds = props.parameter.brandIds.concat(props.result.brandIds || []);
    }
};

export const AddSortFilter: HandlerType = props => {
    if (props.parameter.sort) {
        props.result.sort = props.parameter.sort;
    }
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyProducts/SetMyProductFilters",
        result: props.result,
    });
};

export const chain = [MergeParameter, AddAttributeValueFilters, ResetPage, AddBrandsValueFilters, DispatchSetProductFilters];

const customAddMyProductsFilters = createHandlerChainRunner(chain, "AddProductFilters");
export default customAddMyProductsFilters;
